import { http } from ".."

export const getTeachers = (adminTeacherId: string) => {
	return http.get(`/teacher-group/get-teachers/${adminTeacherId}`, {})
}

